import { TLOSModel } from '@/features/common/types';

type Props = {
  value: TLOSModel | null;
};

export const UpdatedTotalLOSRenderer = ({ value }: Props) =>
  value ? value.displayValue : '';
